import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Contacts from "@/pages/Contacts";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import Proposals from "@/pages/Proposals";
import OperationsInProgress from "@/pages/OperationsInProgress";
import OperationDetail from "@/pages/OperationDetail";
import Evaluation from "@/pages/Evaluation";
import Quotes from "@/pages/Quotes";
import Followups from "@/pages/Followups";
import ConcludedOps from "@/pages/ConcludedOps";
import Settings from "@/pages/Settings";
import Performance from "@/pages/Performance";
import Leads from "@/pages/Leads";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen grid place-items-center">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="lead" element={<Leads />} />
              <Route path="contatti" element={<Contacts />} />
              <Route path="immobili" element={<Properties />} />
              <Route path="mappa" element={<Navigate to="/immobili" replace />} />
              <Route path="immobili/:id" element={<PropertyDetail />} />
              <Route path="proposte" element={<Proposals />} />
              <Route path="operazioni-in-corso" element={<OperationsInProgress />} />
              <Route path="operazioni/:id" element={<OperationDetail />} />
              <Route path="valutazione" element={<Evaluation />} />
              <Route path="preventivi" element={<Quotes />} />
              <Route path="followup" element={<Followups />} />
              <Route path="operazioni" element={<ConcludedOps />} />
              <Route path="impostazioni" element={<Settings />} />
              <Route path="performance" element={<Performance />} />
            </Route>
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
